import React from 'react'
import Footer from '../footer'
import Header from '../header'

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <main style={{paddingTop: '100px'}}>
        {children}
      </main>
      <Footer />
    </>
  )
}

export default Layout
